import { Flex, Skeleton } from 'antd';
import { spacing } from '../../theming';
import { cardStyle } from './vinExtractionStyles';
import styles from './StatCards.module.scss';

// the same shape as the ready stats: the database card, then the five period cards (SC-QA-102)
const PERIOD_CARDS = 5;

const StatsLoadingState = () => (
    <Flex vertical gap={spacing[3]} data-testid="vin-stats-loading">
        <div style={cardStyle}>
            <Skeleton active title={false} paragraph={{ rows: 3 }} />
        </div>
        <div className={styles.periodGrid}>
            {Array.from({ length: PERIOD_CARDS }, (_, index) => (
                <div key={index} style={cardStyle}>
                    <Skeleton active title={false} paragraph={{ rows: 2 }} />
                </div>
            ))}
        </div>
        <div style={cardStyle}>
            <Skeleton active paragraph={{ rows: 6 }} />
        </div>
    </Flex>
);

export default StatsLoadingState;
